import { PURCHASING_TABLES } from "./viewDbPurchasingTables";

const requisitions = new Set(["stock_requisitions", "stock_requisition_lines"]);
const dispatches = new Set(["stock_dispatch_notes", "stock_dispatch_note_lines"]);
const rawTables = new Set(Object.keys(PURCHASING_TABLES).filter((table) => !requisitions.has(table) && !dispatches.has(table)));
export const isPurchasingAdminTable = (table) => rawTables.has(table) || requisitions.has(table) || dispatches.has(table);
export const isScopedStockAdminTable = (table) => requisitions.has(table) || dispatches.has(table);
const can = (user, permission) => Number(user?.id) === 1 || user?.permissions?.[permission] === true;
export function canReadAdminTable(user, table) {
  if (!user?.id || !table) return false;
  if (rawTables.has(table)) return Number(user.id) === 1;
  if (requisitions.has(table)) return can(user, "purchasing.stock.requisitions") || can(user, "purchasing.stock.dispatched");
  if (dispatches.has(table)) return can(user, "purchasing.stock.dispatched");
  return true; // Unrelated PMS routes retain their own existing server permissions.
}
export function canDeleteAdminTable(user, table) {
  if (!canReadAdminTable(user, table)) return false;
  if (requisitions.has(table)) return can(user, "purchasing.stock.requisitions") &&
    can(user, `purchasing.stock.requisitions.${table === "stock_requisitions" ? "delete" : "update"}`);
  if (rawTables.has(table) || dispatches.has(table)) return false;
  return !["users", "roles", "role_business_units"].includes(table);
}
